import { Component, Input, OnInit, Output, EventEmitter, ElementRef, ViewChild, SimpleChanges } from '@angular/core';
import { RefreshButtonState } from '../../enum/refreshButtonState';




@Component({
  selector: 'app-refresh-button',
  templateUrl: './refresh-button.component.html',
  styleUrls: ['./refresh-button.component.scss']
})
export class RefreshButtonComponent implements OnInit {

  @Input() date: Date | null = null;
  @Input() state: RefreshButtonState = RefreshButtonState.IDLE;
  @Output() buttonClick = new EventEmitter<void>();
  @ViewChild("buttonElement") buttonElt!: ElementRef;
  isLoading: boolean = false;
  isIdle: boolean = true;
  isSuccess: boolean = false;
  
  constructor() {
  }

  ngOnInit(): void {
  }

  onClick() {
    const oldDate = this.date;
    this.buttonClick.emit();
    
  }

  ngAfterViewChecked() {
    if (!this.isLoading) {
      this.buttonElt.nativeElement.blur();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['state']) {
      this.isLoading = this.state === RefreshButtonState.LOADING;
      this.isIdle    = this.state === RefreshButtonState.IDLE;
      this.isSuccess = this.state === RefreshButtonState.SUCCESS;
    }
  }

}